import { useQuery } from "@tanstack/react-query";
import OCGatewayClient from "../client/OCGatewayClient";
import { gatewayUserScopedQueryOptions } from "./gatewayQueryUtils";

export interface DeviceTelemetryMetric {
    time: string | number;
    measureName: string;
    value: number | string;
}

export function useDeviceTelemetryMetricsQuery(deviceId: string) {
    const query = useQuery({
        queryKey: ['getDeviceTelemetryMetrics', deviceId],
        enabled: !!deviceId,
        queryFn: async () => {
            return OCGatewayClient.request('getDeviceTelemetryMetrics', {
                deviceId
            }) as Promise<DeviceTelemetryMetric[]>;
        },
        ...gatewayUserScopedQueryOptions,
        staleTime: 30 * 1000,
        gcTime: 1000 * 60 * 60,
    });

    return query;
}
